import $ from 'jquery';
import Swal from 'sweetalert2';
import { templateAddFormats } from '~loader/loader-template';
import { convertToUnit } from '~src/utils';
import { getAxiosClient } from '~src/api';
import { renderLoader } from '~loader/renderLoader';
import { getState, getStatePure, modifyState } from '~src/state';
import { loadSelectFormats } from './loadSelectFormats';
import { loadSelectOrientation } from './loadSelectOrientation';
import { isFormatSelectedFromSelect } from './isFormatSelectedFromSelect';
import { isOrientationFormatSelectedFromSelect } from './isOrientationFormatSelectedFromSelect';
import { formatAutoSelect } from './formatAutoSelect';
import { addFormatToProjectType } from './addFormatToProjectType';
import { isLoggedUserGlobalEditor } from '~src/user';
import { FEATURES, isFeatureEnabled } from '../../features';

let isCustomFormatSelected = false;

const displayDefaultFormats = (orientation) => {
  const projectType = getState('selected.tipo');

  let orientationText;
  if (orientation === 'h') {
    orientationText = 'Orizzontale';
  }
  if (orientation === 'v') {
    orientationText = 'Verticale';
  }
  if (orientation === 's') {
    orientationText = 'Quadrato';
  }

  const rawFormats = projectType.default_formats;
  const formats = rawFormats.filter((i) => i.orientation === orientation);
  loadSelectFormats(formats, orientationText, projectType.objectId);
};

const calcOrientation = (width, height) => {
  if (width > height) {
    return 'h';
  } else if (height > width) {
    return 'v';
  } else {
    return 's';
  }
};

const checkCustomFormatAlreadyExisting = (width, height) => {
  const projectType = getState('selected.tipo');

  // I only want to compare custom formats with custom sizes
  // The same list contains custom formats which point to a
  // defualt format which is already covered by projectType.default_formats
  const customFormats = window.editorLoader.formats[
    projectType.objectId
  ].formats.items.filter((format) => format.width && format.height);

  // I mix custom and default formats in a single list
  const allFormats = [...projectType.default_formats, ...customFormats];

  return allFormats.find((format) => {
    return format.width === width && format.height === height;
  });
};

const changeNewFormatOrientation = async (orientation) => {
  $('#formats-select').empty();

  $('#orientamento-verticale').addClass('selected');
  $('.btn-orientation').removeClass('selected');
  $(`[data-orientation="${orientation}"]`).addClass('selected');

  window.editorLoader.newFormatOrientation = orientation;

  await displayDefaultFormats(orientation);
};

const onClickChangeNewFormatOrientation = (event) => {
  event.preventDefault();
  const orientation = $(event.target).val();
  $('#new-editor-format-width-display').val(0);
  $('#new-editor-format-height-display').val(0);
  changeNewFormatOrientation(orientation);

  if (orientation === 'c') {
    isCustomFormatSelected = true;
  } else {
    isCustomFormatSelected = false;
  }

  const isOrientationSelected = isOrientationFormatSelectedFromSelect();

  if (isOrientationSelected) {
    if (isCustomFormatSelected) {
      $('#format-select-container').hide();
      $('#format-create-container').show();
    } else {
      $('#format-create-container').hide();
      $('#format-select-container').show();
    }
  } else {
    $('#format-select-container').hide();
    $('#format-create-container').hide();
  }

  if (!isCustomFormatSelected) {
    const isFormatSelected = isFormatSelectedFromSelect();
    if (isFormatSelected) {
      $('#form-info-formats').show();
    } else {
      $('#form-info-formats').hide();
    }
  }
};

/**
 * This function validates the input when a new format is created.
 * - We want to make sure that the format dimensions respect our min/max limits
 * - The custom format is not a duplicate of another custom format or a default format
 */
const validateCustomFormatSize = async () => {
  const width = $('#new-editor-format-width-custom').val();
  const height = $('#new-editor-format-height-custom').val();
  const unit = $('#new-editor-format-unit-custom').val();

  if (!width || !height) {
    $('#custom-form-error').hide();
    $('.swal2-confirm').attr('disabled', true);
    return;
  }

  const widthPx = convertToUnit(unit, 'px', width);
  const heightPx = convertToUnit(unit, 'px', height);

  const existingFormat = checkCustomFormatAlreadyExisting(widthPx, heightPx);

  if (existingFormat) {
    const projectType = getState('selected.tipo');
    const selectedFormats = window.editorLoader.formats[projectType.objectId];
    const selectedFormatsItems = selectedFormats.formats.items;
    if (
      selectedFormatsItems.some(
        (formatSelected) =>
          formatSelected.editor_project_formats_default_pointer?.objectId ===
            existingFormat.objectId ||
          formatSelected.objectId === existingFormat.objectId
      )
    ) {
      $('#custom-form-error').text(
        `Esiste già un formato con queste dimensioni: ${existingFormat.name}`
      );
      $('#custom-form-error').show();
      $('.swal2-confirm').attr('disabled', true);
    } else {
      $('#custom-form-error').text(
        `Esiste già un formato con queste dimensioni: ${existingFormat.name}`
      );
      $('#custom-form-error').show();
      $('.swal2-confirm').attr('disabled', true);
    }

    return;
  }

  const minThresholdPx = 100; // pixels
  const maxThresholdPx = 15000; // pixels
  const minThreshold = convertToUnit('px', unit, minThresholdPx);
  const maxThreshold = convertToUnit('px', unit, maxThresholdPx);
  let errorMessage;

  if (widthPx < minThresholdPx) {
    errorMessage = `La larghezza minima è ${minThreshold}`;
  } else if (widthPx > maxThresholdPx) {
    errorMessage = `La larghezza massima è ${maxThreshold}`;
  } else if (heightPx < minThresholdPx) {
    errorMessage = `L'altezza minima è ${minThreshold}`;
  } else if (heightPx > maxThresholdPx) {
    errorMessage = `L'altezza massima è ${maxThreshold}`;
  }

  if (errorMessage) {
    $('#custom-form-error').text(errorMessage);
    $('#custom-form-error').show();
    $('.swal2-confirm').attr('disabled', true);
  } else {
    $('.swal2-confirm').attr('disabled', false);
    $('#custom-form-error').hide();
  }
};

export function onChangeFormatSizeConversionHandler() {
  const isFormatSelected = isFormatSelectedFromSelect();
  if (isFormatSelected) {
    $('#form-info-formats').show();
  }

  const widthPx = $('#new-editor-format-width').val();
  const heightPx = $('#new-editor-format-height').val();
  const unit = $('#new-editor-format-unit').val();

  let width;
  let height;

  if (unit === 'px') {
    width = widthPx;
    height = heightPx;
  } else {
    width = convertToUnit('px', unit, widthPx, window.editorLoader.defaultDPI);
    height = convertToUnit(
      'px',
      unit,
      heightPx,
      window.editorLoader.defaultDPI
    );
  }

  $('#new-editor-format-width-display').val(width);
  $('#new-editor-format-height-display').val(height);
}

export const createNewFormat = async () => {
  let createNewFormatObj = {};
  window.editorLoader.newFormatOrientation = ''; // resets the form and logic of new format modal

  const projectType = getState('selected.tipo');
  const isGlobalEditor = await isLoggedUserGlobalEditor();

  const createFormats =
    (await isFeatureEnabled(FEATURES.CREATE_FORMATS, false)) || isGlobalEditor;

  try {
    // STEP 1: Format Selection
    const step1Result = await Swal.fire({
      title: '<div class="titolo-text color-format">Aggiungi un formato</div>',
      html: `
        <p class="text-center loader-container-subtitle color-format">
            Seleziona uno dei formati per aggiungerlo a quelli che utilizzi per il progetto selezionato
        </p>
        <div class="container-fluid editor-loader-menu-containers p-2 mb-3">
          <h5 class=" text-left loader-container-title color-format">
            Orientamento
          </h5>
          <p class="text-left loader-container-subtitle color-format">
          Seleziona l'orientamento del formato che vuoi aggiungere
        </p>

          <select id="formats-select-orientation">
            <option value="h">Orizzontale</option>
            <option value="v">Verticale</option>
            <option value="s">Quadrato</option>
            ${createFormats ? '<option value="c">Personalizzato</option>' : ''}
          </select>
        </div>

        <div id="format-select-container">
            <div class="container-fluid editor-loader-menu-containers p-2 mb-3">
              <h5 class=" text-left loader-container-title color-format">
                Formati
              </h5>
              <p class=" text-left loader-container-subtitle color-format">
                Seleziona un formato dalla lista
              </p>
              <select id="formats-select"> </select>

              <form id="editor-format-choose-dimensions">
                <div id="form-info-formats" class="form-row">
                    <div class="col">
                        <div class="dettaglio-text">Larghezza</div>
                        <input type="hidden" disabled="disabled" class="form-control" placeholder="" id="new-editor-format-width">
                        <input type="number" disabled="disabled" class="form-control" placeholder="Larghezza" id="new-editor-format-width-display">
                    </div>
                    <div class="col">
                        <div class="dettaglio-text">Altezza</div>
                            <input type="hidden" disabled="disabled" class="form-control" placeholder="" id="new-editor-format-height">
                            <input type="number" disabled="disabled" class="form-control" placeholder="Altezza" id="new-editor-format-height-display">
                        </div>
                    <div class="col">
                        <div class="dettaglio-text">Misura</div>
                        <select class="form-control" id="new-editor-format-unit">
                            <option value="cm" selected="selected">Centimetri</option>
                            <option value="mm">Millimetri</option>
                            <option value="px">Pixels</option>
                        </select>
                    </div>
                </div>
                </form>
              </div>
          </div>
          <div id="format-create-container">
            <div class="container-fluid editor-loader-menu-containers p-2 mb-3">
              <h5 class=" text-left loader-container-title color-format">
                Formato personalizzato
              </h5>
              <p class="text-left loader-container-subtitle color-format">
                Crea un nuovo formato personalizzato
              </p>

              <form id="editor-format-choose-dimensions-custom">
                <div id="form-info-formats-custom" class="form-row">
                  <div class="col">
                    <div class="dettaglio-text">Misura</div>
                    <select class="form-control" id="new-editor-format-unit-custom">
                      <option value="cm" selected="selected">Centimetri</option>
                      <option value="mm">Millimetri</option>
                      <option value="px">Pixels</option>
                    </select>
                  </div>

                  <div class="col">
                    <div class="dettaglio-text">Larghezza</div>
                    <input type="text" class="form-control" placeholder="Larghezza" id="new-editor-format-width-custom" />
                  </div>

                  <div class="col">
                    <div class="dettaglio-text">Altezza</div>
                    <input type="text" class="form-control" placeholder="Altezza" id="new-editor-format-height-custom" />
                  </div>
                </div>
              </form>
                <div class="alert alert-danger" role="alert" id="custom-form-error" style="display: none">
                </div>
              </div>
          </div>`,
      showCancelButton: true,
      showLoaderOnConfirm: true,
      reverseButtons: true,
      confirmButtonColor: '#278e8e',
      confirmButtonText: 'Avanti &rarr;',
      willOpen: async () => {
        // Setup initial state
        $('.swal2-confirm').attr('disabled', 'disabled');
        $('#format-select-container').hide();
        $('#format-create-container').hide();

        // Load orientation select and bind events
        loadSelectOrientation();

        // Remove previous event listeners to avoid duplicates
        $('body').off('change', '#formats-select-orientation');
        $('body').off('input', '#new-editor-format-height-custom');
        $('body').off('input', '#new-editor-format-width-custom');
        $('body').off('change', '#new-editor-format-unit-custom');
        $('body').off('change', '#new-editor-format-unit');

        // Bind new event listeners
        $('body').on(
          'change',
          '#formats-select-orientation',
          onClickChangeNewFormatOrientation
        );

        $('body').on('input', '#new-editor-format-height-custom', (event) => {
          event.currentTarget.value = event.currentTarget.value
            .replace(/[^0-9.]/g, '')
            .replace(/(\..*?)\..*/g, '$1');
          validateCustomFormatSize();
        });

        $('body').on('input', '#new-editor-format-width-custom', (event) => {
          event.currentTarget.value = event.currentTarget.value
            .replace(/[^0-9.]/g, '')
            .replace(/(\..*?)\..*/g, '$1');
          validateCustomFormatSize();
        });

        $('body').on('change', '#new-editor-format-unit-custom', (event) => {
          const unit = event.currentTarget.value;
          const width = $('#new-editor-format-width-custom').val();
          const height = $('#new-editor-format-height-custom').val();
          const previousUnit = getStatePure('createNewFormatSize', 'cm');

          if (previousUnit && width && height) {
            const widthInNewUnit = convertToUnit(previousUnit, unit, width);
            const heightInNewUnit = convertToUnit(previousUnit, unit, height);

            $('#new-editor-format-width-custom').val(widthInNewUnit);
            $('#new-editor-format-height-custom').val(heightInNewUnit);
          }

          modifyState('createNewFormatSize', unit);
          validateCustomFormatSize();
        });

        $('body').on('change', '#new-editor-format-unit', () => {
          onChangeFormatSizeConversionHandler();
        });

        // Set initial orientation
        const projectHasDefaultHorizontalFormats = projectType.default_formats.some(
          (format) => format.orientation === 'h'
        );

        const initialOrientation = projectHasDefaultHorizontalFormats
          ? 'h'
          : 'v';
        await changeNewFormatOrientation(initialOrientation);
      },
      preConfirm: () => {
        // Collect data from step 1
        let width, height, unit;

        if (isCustomFormatSelected) {
          unit = $('#new-editor-format-unit-custom').val();
          width = $('#new-editor-format-width-custom').val();
          height = $('#new-editor-format-height-custom').val();
        } else {
          width = $('#new-editor-format-width').val();
          height = $('#new-editor-format-height').val();
          unit = $('#new-editor-format-unit').val();
        }

        // Store the data for the next step
        Object.assign(createNewFormatObj, { width, height, unit });
        return true; // Continue to next step
      },
    });

    // Check if user cancelled step 1
    if (!step1Result.isConfirmed) {
      return; // Exit if cancelled
    }

    // STEP 2: Name and Create Format
    const step2Result = await Swal.fire({
      title: 'Vuoi abbinare il formato al progetto?',
      confirmButtonText: 'Abbina',
      input: 'text',
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonColor: '#278e8e',
      showLoaderOnConfirm: true,
      willOpen: () => {
        // Set the input field based on format type
        if (isCustomFormatSelected) {
          $('.swal2-input').val(
            `${createNewFormatObj.width} x ${createNewFormatObj.height} ${createNewFormatObj.unit}`
          );
          $('.swal2-input').prop('disabled', false);
        } else {
          $('.swal2-input').val(
            window.editorLoader.newFormatRelation.text || ''
          );
          $('.swal2-input').prop('disabled', true);
        }
      },
      preConfirm: async (name) => {
        if (!name) {
          Swal.showValidationMessage('Nome non valido');
          return false;
        }

        // Add name to our format object
        Object.assign(createNewFormatObj, { name });

        // Convert dimensions to pixels if custom format
        if (isCustomFormatSelected) {
          createNewFormatObj.width = convertToUnit(
            createNewFormatObj.unit,
            'px',
            createNewFormatObj.width,
            300
          );
          createNewFormatObj.height = convertToUnit(
            createNewFormatObj.unit,
            'px',
            createNewFormatObj.height,
            300
          );
        }

        // Prepare API payload
        let payload = {};

        if (isGlobalEditor && isCustomFormatSelected) {
          // Global format creation
          payload = {
            width: parseFloat(createNewFormatObj.width),
            height: parseFloat(createNewFormatObj.height),
            unit: 'px',
            name: createNewFormatObj.name,
            isGlobal: true,
            orientation: calcOrientation(
              createNewFormatObj.width,
              createNewFormatObj.height
            ),
            dpi: 300,
          };
        } else if (
          window.editorLoader.newFormatRelation.custom ||
          isCustomFormatSelected
        ) {
          // Custom user format creation
          payload = {
            width: parseFloat(createNewFormatObj.width),
            height: parseFloat(createNewFormatObj.height),
            unit: 'px',
            name: createNewFormatObj.name,
            isCustom: true,
            orientation: calcOrientation(
              createNewFormatObj.width,
              createNewFormatObj.height
            ),
            dpi: 300,
          };
        } else {
          // Format linking
          payload = {
            editor_project_formats_default_pointer:
              window.editorLoader.newFormatRelation.formatobjectid,
            isCustom: false,
            name: createNewFormatObj.name,
          };
        }

        // Add project type pointer if not global
        if (!(isGlobalEditor && isCustomFormatSelected)) {
          if (projectType.isGlobal) {
            payload.editor_project_types_default_pointer = projectType.objectId;
          } else {
            payload.editor_project_types_pointer = projectType.objectId;
          }
        }

        // Make API call
        try {
          const httpClient = await getAxiosClient();
          const response = await httpClient.post(
            `${process.env.PARSE_API_URL}/editor_project_formats${
              isGlobalEditor && isCustomFormatSelected ? '_default' : ''
            }`,
            { data: payload }
          );

          if (response.status !== 200) {
            Swal.showValidationMessage('Qualcosa è andato storto');
            return false;
          }

          // Handle post-creation tasks
          if (isGlobalEditor) {
            await addFormatToProjectType(
              projectType.objectId,
              response.data.data.objectId
            );
          }

          window.editorLoader.forceFetchFormats = true;
          await renderLoader();

          if (!(isGlobalEditor && isCustomFormatSelected)) {
            const formatId = response.data.data.objectId;
            await formatAutoSelect(formatId);
          }

          return true;
        } catch (error) {
          console.error(error);
          Swal.showValidationMessage(
            `Qualcosa è andato storto: ${error.message}`
          );
          return false;
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    });

    // STEP 3: Success Message (only if step 2 was successful)
    if (step2Result.isConfirmed) {
      await Swal.fire({
        title: 'Creato!',
        html: 'Il nuovo formato &egrave; stato creato e selezionato.',
        icon: 'success',
        confirmButtonColor: '#278e8e',
      });
      templateAddFormats();
    }
  } catch (error) {
    console.error('Error in createNewFormat:', error);
    await Swal.fire({
      title: 'Errore!',
      html: `Qualcosa &egrave; andato storto: ${error.message}`,
      icon: 'error',
      confirmButtonColor: '#278e8e',
    });
  }
};
